import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private _active = null;
  private _requestCount = 0;

  get active(): boolean {
    return this._active;
  }

  show() {
    this._requestCount++;
    if (this._requestCount === 1) {
      this._active = true;
    }
  }

  hide() {
    if (this._requestCount > 0) {
      this._requestCount--;
      if (this._requestCount === 0) {
        this._active = false;
      }
    }
  }

}
